<template>
  <div class="searchWrapper">
    <GlobalEvents
      @keyup.arrow-up="focusPrev"
      @keyup.arrow-down="focusNext"
      @keypress.enter="applyFocusedIndex"
      @keydown.esc="clearSearch"
    />
    <SearchInput
      ref="searchInputComponent"
      @change="inputChange"
      @enter="onSearch"
      @iconClick="onSearch"
      @arrowDown="focusNext"
      @arrowUp="focusPrev"
      @clear="clearSearch"
    />
    <SearchAutoCompleteList v-show="isShowAutoComplete">
      <SearchAutoCompleteListItem
        @itemClick="selectIndex(index)"
        v-for="(item, index) in locationSearchResults"
        :item="item"
        :selected="index | selectedItem(focusedSearchResultIndex)"
        v-bind:key="index"
      />
    </SearchAutoCompleteList>
  </div>
</template>

<script>
import GlobalEvents from 'vue-global-events'
import SearchInput from '@/components/Shared/Simulation/SimulationContentDeliverySearchInput'
import SearchAutoCompleteList from '@/components/Shared/Simulation/SimulationContentDeliverySearchAutoCompleteList'
import SearchAutoCompleteListItem from '@/components/Shared/Simulation/SimulationContentDeliverySearchAutoCompleteListItem'
import { mapActions, mapGetters } from 'vuex'
import { SimulationLocation } from '@/models/Simulation/SimulationFormDelivery'
export default {
  name: 'SimulationContentDeliverySearch',
  components: {
    SearchInput,
    SearchAutoCompleteList,
    SearchAutoCompleteListItem,
    GlobalEvents,
  },
  filters: {
    selectedItem(index, selectedIndex) {
      return index === selectedIndex
    },
  },
  props: {
    selectedGroup: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      keyword: '',
    }
  },
  computed: {
    ...mapGetters('simulation', [
      'isSearching',
      'isShowAutoComplete',
      'locationSearchResults',
      'focusedSearchResultDescription',
      'focusedSearchResultIndex',
      'isFirstSearchResultIndex',
      'isLastSearchResultIndex',
      'isFocusedOnAutoComplete',
    ]),
    searchInput() {
      return this.$refs.searchInputComponent
    },
    isLatLng() {
      const [lat, lng] = this.latLng
      return !isNaN(lat) && !isNaN(lng) && lat < 100 && lng > 100
    },
    latLng() {
      return this.keyword.split(/\s+/).map(Number)
    },
  },
  methods: {
    ...mapActions('simulation', {
      searchLocation: 'SEARCH_LOCATION',
      setFocusIndex: 'SET_FOCUS_INDEX',
      focusNextSearchResult: 'FOCUS_NEXT_SEARCH_RESULT',
      focusPrevSearchResult: 'FOCUS_PREV_SEARCH_RESULT',
      focusOutSearchResult: 'FOCUS_OUT_SEARCH_RESULT',
      clearSearchResult: 'CLEAR_SEARCH_RESULT',
      selectLocation: 'SELECT_LOCATION',
    }),
    inputChange(keyword) {
      this.keyword = keyword
      if (!keyword) this.clearSearchResult()
    },
    async onSearch() {
      if (!this.keyword) {
        return false
      }

      // 検索候補のフォーカスを外す
      this.focusOutSearchResult()

      /**
       * 経度・緯度検索の場合は
       * 直接地点を登録する
       */
      if (this.isLatLng) {
        const [lat, lng] = this.latLng
        const location = await SimulationLocation.assignByLngLat(lng, lat)
        this.selectLocation(location)
        this.selectedGroup.addLocation(location)
      }
      this.searchLocation({ query: this.keyword })
    },
    clearSearch() {
      this.searchInput.clearKeyword()
      this.clearSearchResult()
    },
    focusNext() {
      if (this.isFirstSearchResultIndex) {
        this.searchInput.$refs.input.blur()
      }
      if (this.isLastSearchResultIndex) {
        return false
      }
      this.focusNextSearchResult()
    },
    focusPrev() {
      if (this.isFirstSearchResultIndex) {
        this.searchInput.$refs.input.focus()
        this.focusOutSearchResult()
        return false
      }
      this.focusPrevSearchResult()
    },
    async selectIndex(index) {
      await this.setFocusIndex(index)
      await this.applyFocusedIndex()
    },
    async applyFocusedIndex() {
      /**
       * 検索候補にフォーカスしていない状態でのEnterを除外する
       */
      if (!this.isShowAutoComplete || !this.isFocusedOnAutoComplete) {
        return false
      }
      const { description } = this.focusedSearchResultDescription
      const location = await SimulationLocation.assignByAddress(description)
      this.selectLocation(location)
      this.selectedGroup.addLocation(location)
    },
  },
}
</script>

<style scoped>
.searchWrapper {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: white;
  width: 400px;
  z-index: 2;
}
</style>
